import script from "./kelola.vue?vue&type=script&setup=true&lang=ts"
export * from "./kelola.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=e2edda66&scoped=true&lang=css&external"
import "./kelola.vue?vue&type=style&index=1&id=e2edda66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2edda66"]])

export default __exports__